function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 4,
  fill: "#EEF5FF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M26.4166 28.25V26.4167C26.4166 25.4442 26.0303 24.5116 25.3426 23.8239C24.655 23.1363 23.7224 22.75 22.7499 22.75H17.2499C16.2775 22.75 15.3448 23.1363 14.6572 23.8239C13.9696 24.5116 13.5833 25.4442 13.5833 26.4167V28.25",
  stroke: "#365DE6",
  strokeWidth: 1.83333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9999 19.0833C22.025 19.0833 23.6666 17.4417 23.6666 15.4167C23.6666 13.3916 22.025 11.75 19.9999 11.75C17.9749 11.75 16.3333 13.3916 16.3333 15.4167C16.3333 17.4417 17.9749 19.0833 19.9999 19.0833Z",
  stroke: "#365DE6",
  strokeWidth: 1.83333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgMember = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMember, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/member.179832a9.svg";
export { ForwardRef as ReactComponent };